import { render, staticRenderFns } from "./UploadDropZone.vue?vue&type=template&id=f3f5bea4&"
import script from "./UploadDropZone.vue?vue&type=script&lang=js&"
export * from "./UploadDropZone.vue?vue&type=script&lang=js&"
import style0 from "./UploadDropZone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports